import React, { type ReactNode } from 'react'        
import { LoadScript } from '@react-google-maps/api'
import { GOOGLE_MAPS_CONFIG } from '../../stores/googleMapsConfig'

type Props = { apiKey: string; children: ReactNode }

export default function GoogleMapsProvider({ apiKey, children }: Props) {
  return (
    <LoadScript
      id={GOOGLE_MAPS_CONFIG.id}
      googleMapsApiKey={apiKey}
      version={GOOGLE_MAPS_CONFIG.version}
      language={GOOGLE_MAPS_CONFIG.language}
      region={GOOGLE_MAPS_CONFIG.region}
      libraries={[...GOOGLE_MAPS_CONFIG.libraries]}
    >
      {children}
    </LoadScript>
  )
}
